import {FETCHED_MY_MATCHED_ORDERS,SET_PENDING_TRANSACTIONS} from '../../types';

export function addPending(dispatch,state,{hash,amount,chain,from,to}){
  let changed = false;
  let newOrders = state.orderbook.my_matched_orders.map(o => {
    if(amount == o.sendsAmount && chain.toUpperCase() == o.sendsFromChain.toUpperCase() && from == o.sendsFromAddress && to == o.sendsToAddress){
      if(!o.yourStatus) {
        changed = true;
        o.yourStatus = 'Sending';
      }
    }
    return o;
  })

  dispatch({
    type:SET_PENDING_TRANSACTIONS,
    payload: {hash,type:"Transfer",chain,to,from,amount}
  })

  if(changed){
    dispatch({
      type:FETCHED_MY_MATCHED_ORDERS,
      payload: newOrders
    })
  }
}
